import { nanoid } from 'nanoid';

// HEAD DATA
export const headData = {
  title: 'Paulo', // e.g: 'Name | Developer'
  lang: 'pt', // e.g: en, es, fr, jp
  description: 'Bem vindo ao meu website', // e.g: Welcome to my website
};

// HERO DATA
export const heroData = {
  title: 'Olá! Eu sou o ',
  name: 'paulocesar.dev',
  subtitle: 'Bem vindo ao meu site',
  cta: 'Saiba mais',
};

// ABOUT DATA
export const aboutData = {
  img: 'profile.jpg',
  paragraphOne: 'Apaixonado em criar aplicações que melhoram a vida dos que '+
  'estão a meu redor',
  paragraphTwo: 'Meu foco é construir aplicações, tanto web quanto mobile, '+
  'imersivas e elaboradas, com código visando boas práticas e um design centrado '+
  'ao usuário',
  paragraphThree: 'Sou formado em Análise e Desenvolvimento de sistemas, pós-graduando em '+
  'Projetos de Aplicativos Móveis Multi-Plataforma. Possuo perfil analítico e '+
  'sou apaixonado pelo universo dos dados.',
  resume: '', // if no resume, the button will not show up
};

// PROJECTS DATA
export const projectsData = [
  {
    id: nanoid(),
    img: 'app_1.jpg',
    title: 'Scalas e Campo Harmonico',
    info: 'Aplicativo gerador de campo harmônico. Consiste em gerar os principais '+
    'campos harmônicos e escalas a partir de uma nota selecionada pelo usuário. São '+
    'geradas as tríades e tétrades, é possível visualizar as versões de shapes dos acordes '+
    'e também sua escala no braço da guitarra.',
    info2: 'Android, Java',
    url: 'https://play.google.com/store/apps/details?id=app.paulo.musica',
    //repo: 'https://github.com/cobidev/react-simplefolio', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'app_2.jpg',
    title: 'Scalas e Campo Harmônico (No Ads)',
    info: 'Versão paga (sem anúncios) do aplicativo, que vem com modos gregos',
    info2: 'Android, Java',
    url: 'https://play.google.com/store/apps/details?id=app.paulo.escalaecampo',
    //repo: 'https://github.com/cobidev/react-simplefolio', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'app_3.jpg',
    title: 'Regra de Três Simples',
    info: 'Aplicativo calculador de regra de três simples',
    info2: 'Android, Kotlin',
    url: 'https://play.google.com/store/apps/details?id=app.paulo',
    //repo: 'https://github.com/cobidev/react-simplefolio', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'app_4.jpg',
    title: 'Clone Do Mercado Livre',
    info: 'Aplicação que simula o app Mercado Livre, explorando conceitos de '+
    'autenticação usando Firebase.',
    info2: 'React Native, Javascript, Node, Firebase',
    //url: 'https://github.com/paulocesar7/react-native-firebase-clone-mercado-livre',
    repo: 'https://github.com/paulocesar7/react-native-firebase-clone-mercado-livre', // if no repo, the button will not show up
  },
];

// CONTACT DATA
export const contactData = {
  cta: 'Se interessou? Estou à disposição!',
  btn: 'Vamos conversar',
  email: 'paulocesarr.dev@gmail.com',
};

// FOOTER DATA
export const footerData = {
  networks: [
    /* {
      id: nanoid(),
      name: 'twitter',
      url: '',
    }, 
    {
      id: nanoid(),
      name: 'codepen',
      url: '',
    },*/
    {
      id: nanoid(),
      name: 'linkedin',
      url: 'https://www.linkedin.com/in/paulo-cesar-rodrigues-da-silva-b3b684116/',
    },
    {
      id: nanoid(),
      name: 'instagram',
      url: 'https://www.instagram.com/paulocesar.dev/',
    },
    /* {
      id: nanoid(),
      name: 'github',
      url: '',
    }, */
  ],
};

// Github start/fork buttons
export const githubButtons = {
  isEnabled: false, // set to false to disable the GitHub stars/fork buttons
};
